import React,{useContext, useState} from 'react'

import { Outlet, Navigate } from 'react-router-dom'


import {UserContex} from '../App'

const ProtectedSuperRoutes = () => {
    const {state, dispatch }= useContext(UserContex)


    const user = JSON.parse( localStorage.getItem("super"))
    

    return(
        user ? <Outlet/> : <Navigate to="/login"/>);
}

export default ProtectedSuperRoutes